

/**
  * @name ProfileUpdatePasswordController
  * @description Service to send the updated password to the API
  * @param {service} updatePasswordFactory The updatePasswordFactory service
  */
function ProfileUpdatePasswordController(
  updatePasswordFactory
) {
  let vm = this;
  vm.updatePassword = function(password) {
    updatePasswordFactory.updatePassword(password);
  };
}

angular
  .module('inkfinder')
  .controller('ProfileUpdatePasswordController',
  ProfileUpdatePasswordController);



// WEBPACK FOOTER //
// ./components/collector/update-password/update-password.controller.js